// Module
var code = `<div class="js-popup-baloon{{#isShown}} show{{/isShown}}">
    <div class="lock-image">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{iconUrl}}"></use>
        </svg>
    </div>
    <div class="js-text">{{.text}}</div>
</div>`;
// Exports
export default code;